import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GTMService } from '@services';
import { DevicesStore, FeatureService, GatewayStore, InstallationFeaturesStore } from '@store';
import { FeatureNames } from '@vi-iot/client/index';
import { Observable } from 'rxjs';
import { InstallationService } from 'src/app/+installations/services/installation.service';
import { SingleRoomControlComponent } from '../../../single-room-control.component';
import { CommissioningService } from '../../commissioning/commissioning.service';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-src-settings-activation',
  templateUrl: './src-settings-activation.component.html',
  styleUrls: ['./src-settings-activation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcSettingsActivationComponent extends SingleRoomControlComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() isInSettingsPage = true;
  roomStatusFeatureUpdatePending$: Observable<boolean>;

  constructor(
    public gatewayStore: GatewayStore,
    public devicesStore: DevicesStore,
    protected featureService: FeatureService,
    protected translate: TranslateService,
    protected installationService: InstallationService,
    protected gtmService: GTMService,
    protected commissioningService: CommissioningService,
    protected installationFeaturesStore: InstallationFeaturesStore
  ) {
    super(
      gatewayStore,
      devicesStore,
      featureService,
      translate,
      installationService,
      gtmService,
      commissioningService,
      installationFeaturesStore
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.roomStatusFeatureUpdatePending$ = this.devicesStore.isFeatureWithPendingUpdates(
      FeatureNames.roomStatus
    );
  }
}
